import React from "react";
import "../styles/Header.css";
import logoIcon from "../assets/mainicon.png";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { auth } from "../firebaseConfig";

const Header = () => {
  const [user, setUser] = useState(null);
  const [prompt, setPrompt] = useState("");
  const navigate = useNavigate();

  const handleLogoutClick = () => {
    auth
      .signOut()
      .then(() => {
        setUser(null);
      })
      .catch((error) => {
        console.error("Error signing out: ", error);
      });
  };

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUser({
          displayName: user.displayName,
          email: user.email,
          photoURL: user.photoURL,
        });

        console.log(user);
      } else {
        console.log("No user logged in");
      }
    });

    return () => unsubscribe();
  }, []);

  const handleLoginClick = () => {
    navigate("/signin");
  };

  const handleSignUpClick = () => {
    navigate("/signup");
  };

  const chatbotPage = () => {
    navigate("/process", { state: { selection: "chatbot" } });
  };

  return (
    <header className="header sticky">
      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid">
          <a className="navbar-brand logo" href="/">
            <img src={logoIcon} alt="Logo" className="logo-icon" />
            <h1 className="logo-text">AI Art Generator</h1>
          </a>
          <button
            className="navbar-toggler custom-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto nav-links">
              <li className="nav-item">
                <a className="nav-link" href="#home">
                  Home
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/process">
                  ImageGen
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" onClick={chatbotPage}>
                  Chatbot
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#features">
                  AI Tools
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#pricing">
                  Pricing
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#faq">
                  FAQs
                </a>
              </li>
            </ul>
            <div className="buttons d-flex">
              {!user && (
                <div className="buttons d-flex">
                  <button className="login-button" onClick={handleLoginClick}>
                    Login
                  </button>
                  <button className="signup-button" onClick={handleSignUpClick}>
                    Sign Up
                  </button>
                </div>
              )}

              {user && (
                <div className="buttons d-flex">
                  <button className="signup-button" onClick={handleLogoutClick}>
                    Logout
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
